/**
 * 商品選択モーダル一覧の「選択」ボタン（data-item-selector-*）。
 * document 委譲で click を処理する。
 *
 * Livewire.on(...) は window 上のイベントのみ受け取るため、
 * Livewire.find(wireId).$dispatch ではなく Livewire.dispatch を使う（component.el へのバブルに依存しない）。
 */
let jpenergyItemSelectorModalDelegatedClickBound = false;

/**
 * @param {MouseEvent} event
 */
function handleItemSelectorProductSelectClick(event) {
    const selectButton = event.target.closest('button[data-item-selector-payload]');
    if (!selectButton) {
        return;
    }
    const encodedPayload = selectButton.dataset.itemSelectorPayload;
    if (typeof encodedPayload !== 'string' || encodedPayload === '') {
        return;
    }
    let payload;
    try {
        payload = JSON.parse(atob(encodedPayload));
    } catch (parseError) {
        console.error('item-selector-modal: invalid data-item-selector-payload', parseError);
        return;
    }
    const eventName = selectButton.dataset.itemSelectorEvent;
    if (!eventName || typeof window.Livewire?.dispatch !== 'function') {
        return;
    }
    window.Livewire.dispatch(eventName, payload);
    const modalInstanceId = selectButton.dataset.itemSelectorModalInstanceId ?? 'default';
    window.dispatchEvent(
        new CustomEvent('item-selector-modal-shell-close', {
            bubbles: true,
            detail: { modalInstanceId: modalInstanceId },
        }),
    );
}

function registerItemSelectorModalDelegatedClick() {
    if (jpenergyItemSelectorModalDelegatedClickBound) {
        return;
    }
    jpenergyItemSelectorModalDelegatedClickBound = true;
    document.addEventListener('click', handleItemSelectorProductSelectClick, true);
}

document.addEventListener('livewire:init', registerItemSelectorModalDelegatedClick);
registerItemSelectorModalDelegatedClick();
